import React from 'react';
import _ from 'lodash';
import shuffle from 'shuffle-array';
import Image from './ImageElement';

export default class ExpoMethods extends React.Component {
  /**
   * If a project include the current tag.
   * @param {object} project
   * @return {bool}
   */
  filterByTag(project) {
    if (this.props.tag !== 'Actualités' && project.tags.includes('Actualités'))
      return false;

    if (project.tags) return project.tags.includes(this.props.tag);
    return false;
  }
  onClickProject(evt, project) {
    if (!project.is_external) {
      if (evt.preventDefault) evt.preventDefault();
      this.props.history.push(this.getProjetLink(project));
      return false;
    }
  }
  getProjetLink(project) {
    return project.link;
  }

  /**
   * Return the project list, if any tag is given to filter,
   * will filter the project list.
   * @return {Array} projects
   */
  projects() {
    console.log('reloadproject');

    let filterfunc = project => !project.tags.includes('Actualités');
    if (!_.isNil(this.props.tag)) filterfunc = this.filterByTag;

    const projects = this.props.store.Projects.filter(filterfunc).filter(
      project => project.main_image
    );

    if (!this.props.currentPage || this.props.currentPage.slug == 'actualites')
      return projects;

    shuffle(projects);

    // Pages Actualités by year
    if (this.props.currentPage === 'ActuYear') {
      const targetYear = parseInt(this.props.match.params.year);
      const actusForYear = getActusForYear(projects, targetYear);
      const featuredActusIds = this.props.store.Options.featuredActus;
      return setFeaturedFirsts(actusForYear, featuredActusIds);
    }
    // Pages Projets
    else {
      const featuredProjectIds = this.props.store.Options.featuredProjects;
      return setFeaturedFirsts(projects, featuredProjectIds);
    }
  }
  getBlockWidth(project) {
    if (this.className == 'ExpoMobile') {
      return 100;
    } else {
      return project.ratio;
    }
  }
  /**
   * Return the image block the project
   * @param {object} project
   * @return {ReactElement}
   */
  imageBlockContent(project) {
    return (
      <div
        className={`${this.className}__block`}
        style={{width: `${this.getBlockWidth(project)}%`}}
      >
        <Image
          className={`${this.className}__image`}
          src={
            this.props.screen === 'desktop'
              ? project.main_image.urlx2
              : project.main_image.urlx3
          }
          alt={project.main_image.name || 'Project'}
        />
        <div className={`${this.className}__title`}>
          {project.month && project.month.value !== '0' && (
            <span>{project.month.label + ' '}</span>
          )}
          {project.year.join('–')}
          <br />
          {project.title}
          {project.subtitle && <div>{project.subtitle}</div>}
        </div>
      </div>
    );
  }
  imageBlock(project) {
    if (!project) return null;
    else if (project.is_external) {
      return (
        <a key={project.id} href={project.external_link} target="_blank">
          {this.imageBlockContent(project)}
        </a>
      );
    } else if (project.is_clickable)
      return (
        <a
          key={project.id}
          href={this.getProjetLink(project)}
          onClick={evt => {
            this.onClickProject(evt, project);
          }}
        >
          {this.imageBlockContent(project)}
        </a>
      );
    else
      return (
        <div
          key={project.id}
          className={`${this.className}__block`}
          style={{width: `${this.getBlockWidth(project)}%`}}
        >
          {this.imageBlockContent(project)}
        </div>
      );
  }
}

const getActusForYear = (actus = [], targetYear) => {
  return actus.filter(actu => {
    if (actu.year.length > 1)
      return actu.year[0] <= targetYear && actu.year[0] >= targetYear;
    else return actu.year[0] == targetYear;
  });
};

const setFeaturedFirsts = (items = [], featuredIds = []) => {
  if (!featuredIds) return items;
  const featuredItems = featuredIds.map(id =>
    items.find(item => item.id === id)
  );
  const notFeaturedItems = items.filter(item => !featuredIds.includes(item.id));
  return [...featuredItems, ...notFeaturedItems];
};
